// @flow
import dayjs from 'dayjs';
import ja from 'dayjs/locale/ja';
import { handleAxiosError } from '../../helpers/axiosHelper';
import ExternalServiceAccessRestrictionClient from './ExternalServiceAccessRestrictionClient';

dayjs.locale(ja);

export type ExternalServiceAccessRestrictionPeriod = {
  startAt: ?string,
  endAt: ?string,
};

export function restrictionHandling(
  serviceName: string,
  notInPeriodFunc: () => void,
) {
  const restrictionClient = new ExternalServiceAccessRestrictionClient();
  restrictionClient
    .fetchPeriod(serviceName)
    .then(response => {
      const period = response.data;
      if (period && period.startAt && period.endAt) {
        inPeriodFunc(serviceName, period.startAt, period.endAt);
      } else {
        notInPeriodFunc();
      }
    })
    .catch(error => {
      // 制限期間の取得に失敗した場合は、ブロックせずに次に進む
      handleAxiosError(error, null, () => {
        notInPeriodFunc();
      });
    });
}

function inPeriodFunc(serviceName: string, startAt: string, endAt: string) {
  const dateFormat = 'YYYY年MM月DD日(dd)HH時mm分';
  const restrictionFrom = dayjs(startAt).format(dateFormat);
  const restrictionTo = dayjs(endAt).format(dateFormat);

  let message = '';
  switch (serviceName) {
    case 'WAN-Sign':
      message =
        '只今、提携している電子署名サービス(WAN-Sign)がメンテナンスを実施しているため、電子署名機能の利用を停止しております。\n\n' +
        `メンテナンス時間：${restrictionFrom} ～ ${restrictionTo}\n\n` +
        'お手数お掛けしますがメンテナンス終了後にご対応をお願いいたします。';
  }
  alert(message);
}
